/* JC · Contact + help pages (sections jc-contact-*). One file for all of them; safe to load more than once.
   · The help desk ([data-jc-ctd]): a topic opens its answer right under that row of tiles (tail on her tile), he hops;
     "That helped" thanks her; "Write to a person" hands the topic to the form. ?topic=<key> opens that answer.
   · The letter ([data-jc-ctf]): topic → prompt, tap-to-start lines, the order number / colours / shop fields; her
     name signs the letter; he leans in and nods while she types; plain-words validation with a summary; after
     sending, the envelope gets today's postmark and her first name.
   · Meet the family ([data-jc-cts]): her colour stands first; bags hop on hover and when added (jc.js adds them).
   · Still stuck ([data-jc-ctc]): his face squishes on a spring.
   · Every answer ([data-jc-ctq]): search as she types (accents and case ignored, a few synonyms), topic chips, marks,
     #deep links that open and scroll, copy link, and her words carried to the contact form when nothing matches.
   No layout reads at start-up (only on her actions or in observers). Reduced motion: no hop, wave, nod or squish. */
(function () {
  'use strict';
  // The few words this script writes itself, in the page's language (window.jcT, from the theme's locale files)
  function jcTx(k, d) { var t = window.jcT; return t && typeof t[k] === 'string' ? t[k] : d; }
  if (window.jcContact) { window.jcContact.boot(document); return; }

  var RM = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  function still() { return RM.matches; }
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function track(name, d) {
    window.dataLayer = window.dataLayer || [];
    var p = { event: 'jc_' + name };
    if (d) Object.keys(d).forEach(function (k) { p[k] = d[k]; });
    window.jcPush(p);
  }
  function sget(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function sset(k, v) { try { if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) { /* private mode */ } }
  function goTo(el, block) { if (el) el.scrollIntoView({ behavior: still() ? 'auto' : 'smooth', block: block || 'start' }); }
  function status(root, text) {
    var s = $('[data-jc-ct-status]', root);
    if (!s) { s = document.createElement('p'); s.className = 'visually-hidden'; s.setAttribute('role', 'status'); s.setAttribute('data-jc-ct-status', ''); root.appendChild(s); }
    s.textContent = '';
    setTimeout(function () { s.textContent = text; }, 40);
  }

  /* ---------- He moves ---------- */
  var MOVES = { 'jc-ct-hop': 'is-hop', 'jc-ct-wave': 'is-wave', 'jc-ct-nod': 'is-nod' };
  function play(el, cls) {
    if (!el || still()) return;
    el.classList.remove('is-hop', 'is-wave', 'is-nod');
    void el.offsetWidth; // restart the animation (on her action only)
    el.classList.add(cls);
  }
  document.addEventListener('animationend', function (e) {
    var c = MOVES[e.animationName];
    if (c && e.target && e.target.classList) e.target.classList.remove(c);
  });

  /* A fixed-step spring for the big face's squish: scale(v, 2 − v) keeps his volume. Sleeps at rest. */
  function squisher(el) {
    var x = 1, v = 0, raf = 0, last = 0, acc = 0, STEP = 1 / 120, K = 380, C = 9;
    function frame(now) {
      acc += Math.min(0.064, (now - last) / 1000); last = now;
      while (acc >= STEP) { v += (-K * (x - 1) - C * v) * STEP; x += v * STEP; acc -= STEP; }
      if (Math.abs(v) < 0.01 && Math.abs(x - 1) < 0.004) { x = 1; v = 0; raf = 0; el.style.setProperty('--sq', '1'); return; }
      el.style.setProperty('--sq', x.toFixed(4));
      raf = requestAnimationFrame(frame);
    }
    return function (dv) {
      if (still()) return;
      v = Math.max(-5, Math.min(5, v + dv));
      if (!raf) { last = performance.now(); acc = 0; raf = requestAnimationFrame(frame); }
    };
  }

  function onSeen(el, ratio, cb) {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { io.disconnect(); cb(); } });
    }, { threshold: ratio });
    io.observe(el);
  }

  /* ---------- Money: the 2-bag saving in her currency, in the store's own format ---------- */
  function formatter(sample) {
    var pre = '', suf = '', grp = ',';
    var m = sample && sample.match(/^(.*?)(\d[\d.,\s]*\d|\d)(.*)$/);
    if (m) {
      pre = m[1]; suf = m[3];
      if (/\.\d{3}/.test(m[2]) && !/,\d{3}/.test(m[2])) grp = '.';
      else if (/\s\d{3}/.test(m[2])) grp = ' ';
      if (window.jcMoneyGrp) grp = window.jcMoneyGrp;   // her currency's own thousands separator (layout/theme.liquid)
      return function (cents) { return pre + window.jcNum(cents, grp) + suf; };
    }
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    return function (cents) {
      try { return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: cur, currencyDisplay: 'narrowSymbol', maximumFractionDigits: 0, minimumFractionDigits: 0 }).format(Math.round(cents / 100)); }
      catch (e) { return cur + ' ' + Math.round(cents / 100); }
    };
  }
  function fillSaves(scope) {
    var rate = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || '1') || 1;
    $$('[data-jc-ct-usd]', scope).forEach(function (b) {
      if (b.textContent) return;
      var cents = parseFloat(b.getAttribute('data-jc-ct-usd')) * rate;
      if (!isFinite(cents) || cents <= 0) return;
      b.textContent = formatter(b.getAttribute('data-fmt') || '')(cents);
      var w = b.closest('[data-jc-ct-save]');
      if (!w) return;
      w.hidden = false;
      var plain = w.parentNode && $('[data-jc-ct-save-plain]', w.parentNode);
      if (plain) plain.hidden = true;
    });
  }

  /* ---------- Copy (email, answer links) ---------- */
  function copyText(t) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(t);
    return new Promise(function (res, rej) {
      var ta = document.createElement('textarea');
      ta.value = t; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0'; ta.style.top = '0';
      document.body.appendChild(ta); ta.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
      ta.remove();
      if (ok) res(); else rej(new Error('copy'));
    });
  }
  function copied(btn, text) {
    var label = $('span', btn), was = label ? label.textContent : '';
    copyText(text).then(function () {
      btn.classList.add('is-done');
      if (label) label.textContent = btn.getAttribute('data-done') || was;
      status(btn.closest('[data-jc-ct-root]') || document.body, btn.getAttribute('data-done') || '');
      clearTimeout(btn.__t);
      btn.__t = setTimeout(function () { btn.classList.remove('is-done'); if (label) label.textContent = was; }, 1800);
    }).catch(function () { /* nothing to copy with: the link itself still works */ });
  }

  /* ---------- The help desk ---------- */
  function initDesk(root) {
    if (root.__jcCt) return;
    root.__jcCt = true;
    var grid = $('[data-jc-ctd-topics]', root), slot = $('[data-jc-ctd-slot]', root);
    if (!grid || !slot) return;
    var tiles = $$('[data-jc-ctd-topic]', grid);
    $$('[data-jc-ctd-ans]', slot).forEach(function (a) { a.hidden = true; });
    root.classList.add('is-ready');
    var open = null, hero = $('.jc-ctd__bag', root);

    // The answer goes right after the last tile on her tile's row, so it opens where she's looking
    function place(tile) {
      var all = $$('.jc-ctd__topic', grid), top = tile.offsetTop, last = tile;
      all.forEach(function (t) { if (Math.abs(t.offsetTop - top) < 4 && all.indexOf(t) > all.indexOf(last)) last = t; });
      if (last.nextElementSibling !== slot) grid.insertBefore(slot, last.nextElementSibling);
      var r = tile.getBoundingClientRect(), g = grid.getBoundingClientRect();
      slot.style.setProperty('--tail', Math.round(r.left - g.left + r.width / 2) + 'px');
    }
    function close() {
      if (!open) return;
      open.tile.setAttribute('aria-expanded', 'false');
      open.ans.hidden = true;
      slot.classList.remove('is-open');
      open = null;
    }
    function show(tile, quiet) {
      var ans = document.getElementById(tile.getAttribute('aria-controls'));
      if (!ans) return;
      if (open && open.tile === tile) { close(); return; }
      if (open) { open.tile.setAttribute('aria-expanded', 'false'); open.ans.hidden = true; }
      place(tile);
      tile.setAttribute('aria-expanded', 'true');
      ans.hidden = false;
      slot.classList.add('is-open');
      var th = $('[data-jc-ctd-thanks]', ans), acts = $('[data-jc-ctd-acts]', ans);
      if (th) th.hidden = true;
      if (acts) acts.hidden = false;
      open = { tile: tile, ans: ans };
      ans.classList.remove('is-in'); void ans.offsetWidth; ans.classList.add('is-in');
      fillSaves(ans);
      if (window.jcCtSwap) window.jcCtSwap(ans);
      play($('[data-jc-ct-hopper]', ans), 'is-hop');
      play(hero, 'is-hop');
      var key = tile.getAttribute('data-key');
      if (!quiet) {
        track('contact_answer', { topic: key });
        // Keep her tile in view and show as much of the answer as fits
        var tr = tile.getBoundingClientRect(), ar = ans.getBoundingClientRect(), need = ar.bottom - window.innerHeight + 16;
        if (need > 0) window.scrollBy({ top: Math.max(0, Math.min(need, tr.top - 12)), behavior: still() ? 'auto' : 'smooth' });
        try { var u = new URL(location.href); u.searchParams.set('topic', key); history.replaceState(history.state, '', u.toString()); } catch (e) { /* old browsers */ }
      }
    }
    grid.addEventListener('click', function (e) {
      var t = e.target.closest('[data-jc-ctd-topic]');
      if (t && grid.contains(t)) { show(t); return; }
      var ok = e.target.closest('[data-jc-ctd-ok]');
      if (ok) {
        var ans = ok.closest('[data-jc-ctd-ans]');
        var th = ans && $('[data-jc-ctd-thanks]', ans);
        if (th) { th.hidden = false; status(root, th.textContent.trim()); }
        ok.hidden = true;
        play(hero, 'is-hop');
        play(ans && $('[data-jc-ct-hopper]', ans), 'is-hop');
        track('contact_answer_helped', { topic: ans ? ans.getAttribute('data-key') : '' });
      }
    });
    var rz = 0;
    window.addEventListener('resize', function () {
      if (!open) return;
      cancelAnimationFrame(rz);
      rz = requestAnimationFrame(function () { if (open) place(open.tile); });
    }, { passive: true });

    // He waves hello once the desk is in view; hovering him makes him hop
    if (hero) {
      onSeen(hero, 0.5, function () { setTimeout(function () { play(hero, 'is-wave'); }, 250); });
      hero.parentNode.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') play(hero, 'is-hop'); });
    }

    // ?topic=<key>: open that answer (the contact page link from the FAQ page carries it)
    // (not when she came straight to the form, #write, or back from sending: the answer would push the form away)
    var want = null;
    try { var u0 = new URL(location.href); want = u0.hash || u0.searchParams.get('contact_posted') ? null : u0.searchParams.get('topic'); } catch (e) { want = null; }
    if (want) {
      var t = tiles.filter(function (x) { return x.getAttribute('data-key') === want; })[0];
      if (t) requestAnimationFrame(function () { show(t, true); });
    }
    root.jcCtd = { close: close, open: function (ans) {
      var t = tiles.filter(function (x) { return x.getAttribute('aria-controls') === ans.id; })[0];
      if (t && !(open && open.tile === t)) show(t, true);
    } };
  }

  /* ---------- The letter ---------- */
  var EMAIL = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)*\.[^\s@.]{2,}$/;
  function initForm(root) {
    if (root.__jcCt) return;
    root.__jcCt = true;
    var sent = $('[data-jc-ctf-sent]', root);
    if (sent) { initSent(root, sent); return; }
    var form = $('form', root);
    if (!form) return;
    form.noValidate = true;
    var radios = $$('.jc-ctf__radio', form);
    var topics = $('[data-jc-ctf-topics]', form), change = $('[data-jc-ctf-change]', form);
    var body = $('[data-jc-ctf-body]', form), email = $('[data-jc-ctf-email]', form), name = $('[data-jc-ctf-name]', form);
    var sig = $('[data-jc-ctf-sig]', form), starters = $('[data-jc-ctf-starters]', form), startList = $('[data-jc-ctf-startlist]', form);
    var note = $('[data-jc-ctf-note]', form), extras = $$('[data-jc-ctf-extra]', form);
    var listen = $('[data-jc-ctf-listen]', form), listenIn = listen && $('[data-jc-ct-hopper]', listen);
    var box = $('[data-jc-ctf-summary]', form), list = $('[data-jc-ctf-summary-list]', form);
    var xIcon = box ? $('.jc-ctf__errh svg', box) : null;
    var heading = $('.jc-ctf__h', root);
    var basePh = body ? body.getAttribute('placeholder') || '' : '';
    var tried = false;

    function checked() { return radios.filter(function (r) { return r.checked; })[0] || null; }
    function setExtras(r) {
      extras.forEach(function (x) {
        var k = x.getAttribute('data-jc-ctf-extra');
        var on = r ? r.hasAttribute('data-' + k) : k === 'order';
        x.hidden = !on;
        $$('input, select, textarea', x).forEach(function (i) { i.disabled = !on; });
      });
    }
    function applyTopic(r, collapse) {
      radios.forEach(function (x) { var l = x.closest('.jc-ctf__chip'); if (l) l.classList.toggle('is-on', x === r); });
      setExtras(r);
      if (body) body.setAttribute('placeholder', (r && r.getAttribute('data-prompt')) || basePh);
      var lines = r ? (r.getAttribute('data-starters') || '').split('|').map(function (s) { return s.trim(); }).filter(Boolean) : [];
      if (startList) {
        startList.textContent = '';
        lines.forEach(function (s) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'jc-ctf__start'; b.setAttribute('data-jc-ctf-start', s);
          b.textContent = s + jcTx('starter_more', '…');
          startList.appendChild(b);
        });
      }
      if (starters) starters.hidden = !lines.length;
      if (note) note.textContent = (r && r.getAttribute('data-note')) || note.getAttribute('data-default') || '';
      if (topics) topics.classList.toggle('is-collapsed', !!(r && collapse));
      if (change) change.hidden = !(r && collapse);
    }
    function pickKey(key, collapse) {
      var r = radios.filter(function (x) { return x.getAttribute('data-key') === key; })[0];
      if (!r) return null;
      r.checked = true;
      applyTopic(r, collapse);
      return r;
    }
    form.addEventListener('change', function (e) {
      if (e.target.classList && e.target.classList.contains('jc-ctf__radio')) { applyTopic(e.target, false); play(listenIn, 'is-nod'); }
    });
    if (change) change.addEventListener('click', function () {
      if (topics) topics.classList.remove('is-collapsed');
      change.hidden = true;
      var c = checked() || radios[0];
      if (c) c.focus();
    });

    // Her name signs the letter
    function sign() { if (sig) sig.textContent = (name && name.value.trim().slice(0, 40)) || sig.getAttribute('data-empty') || ''; }
    if (name) name.addEventListener('input', sign);

    // The letter grows with her words; he leans in and nods while she types
    var minH = 0, nodAt = 0;
    function grow() {
      if (!body) return;
      if (!minH) minH = body.offsetHeight;
      body.style.height = 'auto';
      body.style.height = Math.max(minH, body.scrollHeight) + 'px';
    }
    if (body) {
      body.addEventListener('input', function () {
        grow();
        var now = Date.now();
        if (now - nodAt > 420) { nodAt = now; play(listenIn, 'is-nod'); }
        if (tried) check(body);
      });
      body.addEventListener('focus', function () { if (listen && !still()) listen.classList.add('is-listening'); });
      body.addEventListener('blur', function () { if (listen) listen.classList.remove('is-listening'); if (tried) check(body); });
    }
    if (email) {
      email.addEventListener('blur', function () { if (tried || email.value.trim()) check(email); });
      email.addEventListener('input', function () { if (tried) check(email); });
    }

    // Tap-to-start lines
    form.addEventListener('click', function (e) {
      var st = e.target.closest('[data-jc-ctf-start]');
      if (!st || !body) return;
      var s = st.getAttribute('data-jc-ctf-start'), v = body.value;
      var add = /[#(]$/.test(s) ? s : s + jcTx('starter_gap', ' ');
      body.value = v + (v && !/\s$/.test(v) ? '\n' : '') + add;
      body.focus();
      try { body.setSelectionRange(body.value.length, body.value.length); } catch (x) { /* ok */ }
      grow();
      play(listenIn, 'is-nod');
      if (tried) check(body);
    });

    // Validation: plain words under the field, a summary on top
    function setErr(input, msg) {
      var wrap = input.closest('.jc-ct-field'), err = document.getElementById(input.id + '-err');
      if (wrap) wrap.classList.toggle('is-bad', !!msg);
      if (msg) input.setAttribute('aria-invalid', 'true'); else input.removeAttribute('aria-invalid');
      if (!err) return;
      err.textContent = '';
      if (msg) {
        if (xIcon) err.appendChild(xIcon.cloneNode(true));
        var sp = document.createElement('span'); sp.textContent = msg; err.appendChild(sp);
      }
    }
    function problem(input) {
      var err = document.getElementById(input.id + '-err'), v = input.value.trim();
      if (input === email) return !v ? err.getAttribute('data-msg-empty') : (EMAIL.test(v) ? '' : err.getAttribute('data-msg-bad'));
      if (input === body) return v.length < 2 ? err.getAttribute('data-msg-empty') : '';
      return '';
    }
    function check(only) {
      var probs = [];
      [email, body].forEach(function (i) {
        if (!i) return;
        var m = problem(i);
        if (!only || only === i) setErr(i, m);
        if (m) probs.push([i, m]);
      });
      if (tried) summary(probs, false);
      return probs;
    }
    function summary(probs, focus) {
      if (!box || !list) return;
      if (!probs.length) { box.hidden = true; return; }
      list.textContent = '';
      probs.forEach(function (p) {
        var li = document.createElement('li'), a = document.createElement('a');
        a.href = '#' + p[0].id; a.textContent = p[1];
        a.addEventListener('click', function (e) { e.preventDefault(); p[0].focus(); });
        li.appendChild(a); list.appendChild(li);
      });
      box.hidden = false;
      if (focus) { box.focus({ preventScroll: true }); goTo(box, 'center'); }
    }
    form.addEventListener('submit', function (e) {
      tried = true;
      var probs = check();
      if (probs.length) {
        e.preventDefault();
        summary(probs, true);
        play(listenIn, 'is-nod');
        track('contact_invalid', { fields: probs.map(function (p) { return p[0] === email ? 'email' : 'message'; }).join(',') });
        return;
      }
      if (box) box.hidden = true;
      sset('jc-ct-name', name ? name.value.trim() : '');
      var btn = $('[data-jc-ctf-send]', form);
      if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
      var r = checked();
      track('contact_submit', { topic: r ? r.getAttribute('data-key') : '' });
      play(listenIn, 'is-hop');
    });
    // Shopify's own errors (after a post): bring her to the list
    if (box && !box.hidden) { tried = true; requestAnimationFrame(function () { box.focus({ preventScroll: true }); goTo(box, 'center'); }); }

    // Start state: the topic from the link (?topic=), her words from the FAQ search, her name
    var key = null;
    try { key = new URL(location.href).searchParams.get('topic'); } catch (e) { key = null; }
    var r0 = checked();
    if (key && !r0) pickKey(key, true); else applyTopic(r0, false);
    var q = sget('jc-help-q');
    if (q && body && !body.value) { body.value = (body.getAttribute('data-q-tpl') || '“[q]”: ').replace('[q]', q); sset('jc-help-q', null); }
    sign();
    if (body && body.value) grow();

    root.jcCtf = {
      pick: function (k) {
        pickKey(k, true);
        goTo(root, 'start');
        if (heading) { heading.setAttribute('tabindex', '-1'); setTimeout(function () { heading.focus({ preventScroll: true }); }, still() ? 0 : 450); }
        setTimeout(function () { play(listenIn, 'is-hop'); }, still() ? 0 : 500);
      }
    };
  }
  function initSent(root, sent) {
    var h = $('[data-jc-ctf-okh]', sent), n = sget('jc-ct-name');
    if (h && n) {
      var tpl = h.getAttribute('data-name-tpl');
      if (tpl && tpl.indexOf('[name]') > -1) h.textContent = tpl.replace('[name]', n.split(/\s+/)[0]);
    }
    sset('jc-ct-name', null);
    var d = $('[data-jc-ctf-date]', sent);
    if (d) { try { d.textContent = new Intl.DateTimeFormat(document.documentElement.lang || undefined, { day: 'numeric', month: 'short' }).format(new Date()); } catch (e) { /* no postmark date */ } }
    requestAnimationFrame(function () {
      goTo(sent, 'center');
      if (h) h.focus({ preventScroll: true });
    });
    setTimeout(function () { play($('[data-jc-ct-hopper]', sent), 'is-hop'); }, still() ? 0 : 650);
    track('contact_sent');
  }

  /* ---------- Meet the family ---------- */
  function initShop(root) {
    if (root.__jcCt) return;
    root.__jcCt = true;
    var cur = window.jcCtCur;
    if (cur) {
      var li = $('[data-slug="' + cur + '"]', root);
      if (li && li.parentNode) {
        li.parentNode.insertBefore(li, li.parentNode.firstElementChild);
        var seen = $('[data-jc-cts-seen]', li);
        if (seen) seen.hidden = false;
      }
    }
    $$('.jc-cts__link', root).forEach(function (l) {
      l.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') play($('[data-jc-ct-hopper]', l), 'is-hop'); });
    });
  }
  document.addEventListener('jc:added', function (e) {
    var t = e.detail && e.detail.trigger, li = t && t.closest ? t.closest('.jc-cts__item') : null;
    if (li) play($('[data-jc-ct-hopper]', li), 'is-hop');
  });

  /* ---------- Still stuck: the big face ---------- */
  function initSquish(el) {
    if (el.__jcCt) return;
    el.__jcCt = true;
    var kick = squisher(el);
    el.addEventListener('pointerdown', function () { kick(-3.2); });
    el.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') kick(-3.2); });
    onSeen(el, 0.6, function () { setTimeout(function () { kick(-3.2); }, 120); });
  }

  /* ---------- Every answer ---------- */
  var SYN = {
    track: ['tracking', 'parcel'], tracking: ['track', 'parcel'], parcel: ['order', 'tracking'], where: ['tracking', 'order'],
    customs: ['duties', 'tax'], duty: ['duties', 'customs'], duties: ['customs'], tax: ['duties', 'customs'], taxes: ['duties', 'customs'],
    refund: ['return', 'money'], money: ['refund'], return: ['refund'], returns: ['refund'], exchange: ['return', 'colour'], swap: ['exchange', 'return'],
    size: ['cm', 'big', 'fits', 'dimensions'], big: ['size', 'cm'], dimensions: ['size', 'cm'], fit: ['fits', 'inside', 'size'], laptop: ['fits', 'inside'],
    strap: ['crossbody'], crossbody: ['strap'], wash: ['clean', 'spot-clean'], clean: ['spot-clean', 'brush'], dirty: ['clean'],
    gift: ['her', 'present'], present: ['gift'], ship: ['shipping', 'delivery'], shipping: ['delivery', 'ship'], delivery: ['shipping', 'arrive'],
    late: ['delivery', 'tracking'], lost: ['tracking', 'damaged'], broken: ['damaged'], damaged: ['wrong'], wrong: ['damaged'],
    color: ['colour'], colors: ['colour'], colour: ['color'], material: ['leather', 'shearling'], fur: ['shearling'], fake: ['real'],
    cancel: ['change'], address: ['change'], jellycat: ['affiliated'], hermes: ['affiliated', 'birkin'], birkin: ['hermes']
  };
  function norm(s) {
    s = String(s || '').toLowerCase();
    if (s.normalize) s = s.normalize('NFKD').replace(/[̀-ͯ]/g, '');
    return s.replace(/[’‘]/g, "'").replace(/\s+/g, ' ');
  }
  function escRe(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  function markText(el, words) {
    var re = new RegExp('(' + words.map(escRe).join('|') + ')', 'gi');
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), nodes = [], n;
    while ((n = walker.nextNode())) { if (n.nodeValue.trim() && n.parentNode && n.parentNode.nodeName !== 'MARK') nodes.push(n); }
    nodes.forEach(function (node) {
      var t = node.nodeValue;
      re.lastIndex = 0;
      if (!re.test(t)) return;
      re.lastIndex = 0;
      var frag = document.createDocumentFragment(), last = 0, m;
      while ((m = re.exec(t))) {
        if (m.index > last) frag.appendChild(document.createTextNode(t.slice(last, m.index)));
        var mk = document.createElement('mark'); mk.className = 'jc-ctq__hl'; mk.textContent = m[0]; frag.appendChild(mk);
        last = m.index + m[0].length;
        if (!m[0].length) re.lastIndex++;
      }
      if (last < t.length) frag.appendChild(document.createTextNode(t.slice(last)));
      node.parentNode.replaceChild(frag, node);
    });
  }
  function initFaq(root) {
    if (root.__jcCt) return;
    root.__jcCt = true;
    var input = $('[data-jc-ctq-input]', root), clear = $('[data-jc-ctq-clear]', root), search = input && input.closest('.jc-ctq__search');
    var chips = $$('.jc-ctq__chip', root), count = $('[data-jc-ctq-count]', root);
    var items = $$('[data-jc-ctq-item]', root), groups = $$('[data-jc-ctq-group]', root);
    var none = $('[data-jc-ctq-none]', root), noneH = $('[data-jc-ctq-none-h]', root), noneGo = $('[data-jc-ctq-none-go]', root);
    if (!items.length) return;
    var marks = items.map(function (it) { return $$('[data-jc-ctq-mark]', it).map(function (m) { return { el: m, html: m.innerHTML }; }); });
    var index = items.map(function (it) { return norm(it.getAttribute('data-s')); });
    var group = 'all', q = '', lastQ = '', autoOpened = [], raf = 0;
    var T = { one: root.getAttribute('data-one') || '1', many: root.getAttribute('data-many') || '[n]', forq: root.getAttribute('data-for') || '“[q]”' };

    // Chinese is typed without spaces ("我要退貨", "運費多少"): a Chinese word also matches when what is left after the
    // question words matches, or, for a longer phrase, at least half of its two-character pieces do.
    var CJK = /[㐀-鿿]/;
    var CJK_FILL = /[，。？！、：；「」『』（）～…?!,.]|請問|可以|怎麼|怎樣|如何|多少|能不能|有沒有|是不是|什麼|甚麼|嗎|呢|吧|的|我們|我|想|要/g;
    function cjkHit(ix, w) {
      var core = w.replace(CJK_FILL, ' ').trim().split(/\s+/).filter(Boolean);
      return core.length > 0 && core.every(function (c) {
        if (ix.indexOf(c) > -1) return true;
        if (c.length < 3) return false;
        var n = 0, k = c.length - 1;
        for (var j = 0; j < k; j++) if (ix.indexOf(c.substr(j, 2)) > -1) n++;
        return n * 2 >= k;
      });
    }
    function hits(i, words) {
      return words.every(function (w) {
        if (index[i].indexOf(w) > -1) return true;
        if (CJK.test(w) && cjkHit(index[i], w)) return true;
        var s = SYN[w];
        return !!s && s.some(function (x) { return index[i].indexOf(x) > -1; });
      });
    }
    function run() {
      raf = 0;
      var words = norm(q).trim().split(' ').filter(function (w) { return w.length > 1 || /\d/.test(w) || /[\u3400-\u9fff]/.test(w); });
      var shown = 0, per = { all: 0 };
      autoOpened.forEach(function (it) { if (!it.__jcUser) it.open = false; });
      autoOpened = [];
      items.forEach(function (it, i) {
        var g = it.getAttribute('data-g'), hit = !words.length || hits(i, words);
        if (hit) { per[g] = (per[g] || 0) + 1; per.all++; }
        var vis = hit && (group === 'all' || group === g);
        it.hidden = !vis;
        if (vis) shown++;
        marks[i].forEach(function (m) { if (m.el.innerHTML !== m.html) m.el.innerHTML = m.html; if (vis && words.length) markText(m.el, words); });
      });
      groups.forEach(function (s) { s.hidden = !$$('[data-jc-ctq-item]', s).some(function (it) { return !it.hidden; }); });
      chips.forEach(function (c) {
        var g = c.getAttribute('data-g'), b = $('b', c), k = per[g] || 0;
        if (b) b.textContent = k;
        c.classList.toggle('is-empty', !k);
      });
      // A handful of results: open them, so she sees why they matched
      if (words.length && shown && shown <= 3) items.forEach(function (it) { if (!it.hidden && !it.open) { it.open = true; autoOpened.push(it); } });
      var qt = q.trim();
      if (count) count.textContent = qt ? (shown === 1 ? T.one : T.many.replace('[n]', shown)) + jcTx('count_join', ' ') + T.forq.replace('[q]', qt) : '';
      if (none) {
        none.hidden = shown > 0;
        if (!shown && noneH) noneH.textContent = (noneH.getAttribute('data-tpl') || '[q]').replace('[q]', qt);
      }
      if (clear) clear.hidden = !qt;
      if (search) search.classList.toggle('has-q', !!qt);
      if (qt && qt !== lastQ) { clearTimeout(run.t); run.t = setTimeout(function () { track('help_search', { q: qt.slice(0, 60), results: shown }); }, 1200); }
      lastQ = qt;
    }
    function later() { if (!raf) raf = requestAnimationFrame(run); }
    if (input) {
      input.addEventListener('input', function () { q = input.value; later(); });
      input.addEventListener('keydown', function (e) { if (e.key === 'Escape' && input.value) { e.preventDefault(); input.value = ''; q = ''; run(); } });
      // ?q= prefills the search
      try { var pq = new URL(location.href).searchParams.get('q'); if (pq) { input.value = pq; q = pq; } } catch (e) { /* ok */ }
    }
    if (clear) clear.addEventListener('click', function () { input.value = ''; q = ''; run(); input.focus(); });
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        group = c.getAttribute('data-g');
        chips.forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
        run();
        track('help_topic', { group: group });
      });
    });
    // "/" jumps to the search (desktop habit)
    document.addEventListener('keydown', function (e) {
      if (e.key !== '/' || e.metaKey || e.ctrlKey || e.altKey || !input) return;
      var a = document.activeElement, tag = a && a.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || (a && a.isContentEditable)) return;
      e.preventDefault(); input.focus();
    });
    // Nothing found: her words come with her to the form
    if (noneGo) noneGo.addEventListener('click', function () { if (q.trim()) sset('jc-help-q', q.trim().slice(0, 120)); });

    // Deep links: #id opens and scrolls; opening one puts its link in the address bar
    items.forEach(function (it) {
      it.addEventListener('toggle', function () {
        if (!it.open) return;
        if (autoOpened.indexOf(it) === -1) {
          it.__jcUser = true;
          try { history.replaceState(history.state, '', '#' + it.id); } catch (e) { /* ok */ }
        }
      });
      $$('summary', it).forEach(function (s) { s.addEventListener('click', function () { it.__jcUser = true; }); });
    });
    function openHash() {
      var id = decodeURIComponent((location.hash || '').slice(1));
      if (!id) return;
      var it = document.getElementById(id);
      if (!it || items.indexOf(it) === -1) return;
      if (it.hidden) { group = 'all'; chips.forEach(function (x) { x.setAttribute('aria-pressed', x.getAttribute('data-g') === 'all' ? 'true' : 'false'); }); if (input) { input.value = ''; q = ''; } run(); }
      it.__jcUser = true;
      it.open = true;
      requestAnimationFrame(function () { goTo(it, 'start'); var s = $('summary', it); if (s) s.focus({ preventScroll: true }); });
    }
    window.addEventListener('hashchange', openHash);
    root.addEventListener('click', function (e) {
      var cp = e.target.closest('[data-jc-ctq-copy]');
      if (!cp) return;
      copied(cp, location.href.split('#')[0] + '#' + cp.getAttribute('data-jc-ctq-copy'));
      track('help_copy_link', { id: cp.getAttribute('data-jc-ctq-copy') });
    });
    if (q) run();
    openHash();
  }

  /* ---------- Everywhere ---------- */
  document.addEventListener('click', function (e) {
    var w = e.target.closest('[data-jc-ct-write]');
    if (w) {
      var f = $('[data-jc-ctf]');
      if (f && f.jcCtf) { e.preventDefault(); f.jcCtf.pick(w.getAttribute('data-jc-ct-write')); track('contact_to_form', { topic: w.getAttribute('data-jc-ct-write') }); }
      return;
    }
    var c = e.target.closest('[data-jc-ct-copy]');
    if (c) { e.preventDefault(); copied(c, c.getAttribute('data-jc-ct-copy')); track('contact_copy_email'); }
  });

  function boot(scope) {
    scope = scope || document;
    if (window.jcCtSwap) {
      if (scope.matches && scope.matches('[data-jc-ct-root]')) window.jcCtSwap(scope);
      $$('[data-jc-ct-root]', scope).forEach(function (r) { window.jcCtSwap(r); });
    }
    $$('[data-jc-ctd]', scope).forEach(initDesk);
    $$('[data-jc-ctf]', scope).forEach(initForm);
    $$('[data-jc-cts]', scope).forEach(initShop);
    $$('[data-jc-ct-squish]', scope).forEach(initSquish);
    $$('[data-jc-ctq]', scope).forEach(initFaq);
    fillSaves(scope);
  }
  window.jcContact = { boot: boot };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  // Theme editor: selecting a topic or a question in the sidebar opens it
  document.addEventListener('shopify:block:select', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var ans = t.closest('[data-jc-ctd-ans]'), desk = ans && ans.closest('[data-jc-ctd]');
    if (ans && desk && desk.jcCtd) desk.jcCtd.open(ans);
    if (t.matches && t.matches('[data-jc-ctq-item]')) { t.hidden = false; t.open = true; }
  });
})();
